
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as TrendUpIconComponent } from "./trend-up-icon.svg";

export const TrendUpIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <TrendUpIconComponent {...props} />;
};
